<form nz-form [formGroup]="form" (ngSubmit)="checkProductionDates()" class="form-section">
  <nz-row [nzGutter]="10" class="form-row" nzJustify="center">
    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="6">
      <nz-form-control>
        <nz-select
          formControlName="company"
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'CHECK_PRODUCTION_DATE_PAGE.FORM.MANUFACTURER' | translate"
        >
          <nz-option *ngFor="let company of companies" [nzValue]="company" [nzLabel]="company"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-col>

    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="6">
      <nz-form-control>
        <input nz-input formControlName="vin" placeholder="VIN" />
      </nz-form-control>
    </nz-col>

    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="6" [nzLg]="4">
      <button
        nz-button
        nzType="primary"
        [disabled]="form.invalid"
        style="width: 100%;"
      >
        {{ 'CHECK_PRODUCTION_DATE_PAGE.FORM.SEARCH' | translate }}
      </button>
    </nz-col>
  </nz-row>
</form>
